module.exports = __webpack_public_path__ + "static/media/4.2_preview.f4971c78.png";